import { Component, ReactPortal } from "react";
import { createPortal } from "react-dom";
import { PortalProps } from "./Portal.types";

class Portal extends Component<PortalProps> {
  el: HTMLDivElement;
  portalId: string;

  constructor(props: PortalProps) {
    super(props);
    this.el = document.createElement("div");
    this.portalId = this.props.portalId || "portal-root";
  }

  componentDidMount(): void {
    // The portal element is inserted in the DOM tree after
    // the Modal's children are mounted, meaning that children
    // will be mounted on a detached DOM node. If a child
    // component requires to be attached to the DOM tree
    // immediately when mounted, for example to measure a
    // DOM node, or uses 'autoFocus' in a descendant, add
    // state to Modal and only render the children when Modal
    // is inserted in the DOM tree.
    let portalRoot = document.getElementById(this.portalId);
    if (!portalRoot) {
      portalRoot = document.createElement("div");
      portalRoot.setAttribute("id", this.portalId);
      document.body.appendChild(portalRoot);
    }
    portalRoot.appendChild(this.el);
  }

  componentWillUnmount(): void {
    const portalRoot = document.getElementById(this.portalId);
    if (portalRoot) {
      portalRoot.removeChild(this.el);
    }
  }

  render(): ReactPortal {
    return createPortal(this.props.children, this.el);
  }
}

export default Portal;
